// @ts-nocheck
import { ComponentType } from 'react'
import { SnackProvider } from 'src/hooks/useSnackbar'

export function withSnackbar<T>(Component: ComponentType<T>) {
    return (props: T) => (
        <SnackProvider>
            <Component {...props} />
        </SnackProvider>
    )
}
